import {Container} from './style'
import React from 'react'

const Footer = ()=>{
    return(
    <Container>
                <span>Email: grsouza135@gmail.com</span>
                {' '}Desenvolvido com 💚 por Gabriel Rocha
    </Container>
    )
}
export default Footer